import React from 'react';
import { Box, Typography } from '@mui/material';

const SitemarkIcon = ({ sx = {} }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: 24,
        height: 24,
        borderRadius: 1,
        backgroundColor: 'primary.main',
        ...sx,
      }}
    >
      <Typography
        variant="h6"
        sx={{
          color: 'white',
          fontWeight: 800,
          fontSize: '0.875rem',
          lineHeight: 1,
        }}
      >
        B
      </Typography>
    </Box>
  );
};

export default SitemarkIcon;

